import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ThanhVienTrangTrai } from 'src/app/shared/ThanhVienTrangTrai.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class ThanhVienTrangTraiService extends BaseService{

    list: ThanhVienTrangTrai[] | undefined;
    list001: ThanhVienTrangTrai[] | undefined;
    formData!: ThanhVienTrangTrai;    
  

    displayColumns001: string[] = ['ID', 'DanhMucTinhThanhID', 'DiaChi', 'Name'];   

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "ThanhVienTrangTrai";
    }
}

